import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Register PWA service worker for offline caching and faster loads
serviceWorkerRegistration.register();

// Core Web Vitals — posts LCP / CLS / FID / FCP / TTFB to
// /api/diagnostics/web-vitals when the backend is reachable. Observational
// only; failures are swallowed.
reportWebVitals();
